const rankingData = [
  {
    name: 'Rankings',
    link: '/rankings-generales/ranking-universidades-2023/',
    rankings: [
      {
        name: 'Top 10 Universidades Chilenas',
        link: '/rankings-generales/ranking-universidades-2023/',
        slug: 'ranking-universidades-2023',
        content: `<p>Desde hace 24 años realizamos este ranking y nuestro objetivo sigue siendo el mismo: entregar información que sirva a los jóvenes y a sus familias para tomar una decisión informada antes de iniciar el proceso de postulación a la educación superior. Es una radiografía del año, de cómo la percepción de calidad que el mercado laboral asocia a cada plantel, la calidad de la gestión institucional, de los académicos y de los alumnos, así como los niveles de investigación alcanzados por las casas de estudio, han avanzado en los últimos 12 meses. Son estas cinco dimensiones con los cuales se construye el ranking.</p>`,
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            data: {
              fundacion: '1888',
              rector: 'Ignacio Sánchez',
              sedes: 'Santiago / Villarrica',
              acreditados: '7',
              puntaje: '792,51',
            },
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            data: {
              fundacion: '1842',
              rector: 'Rosa Devés',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '766,20',
            },
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            data: {
              fundacion: '1919',
              rector: 'Carlos Saavedra',
              sedes: 'Concepción / Chillán / Los Ángeles',
              acreditados: '7',
              puntaje: '657,94',
            },
          },

          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            data: {
              fundacion: '1924',
              rector: 'Nelson Vásquez',
              sedes: 'Valparaíso / Viña del Mar / Quilpué / Quillota',
              acreditados: '6',
              puntaje: '728,93',
            },
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            data: {
              fundacion: '1926',
              rector: 'Juan Yuz',
              sedes: 'Valparaíso / Viña del Mar / Santiago / Concepción',
              acreditados: '6',
              puntaje: '749,96',
            },
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            data: {
              fundacion: '1988',
              rector: 'Harald Beyer',
              sedes: 'Santiago / Viña del Mar',
              acreditados: '6',
              puntaje: '645,50',
            },
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            data: {
              fundacion: '1954',
              rector: 'Hans Richter',
              sedes: 'Valdivia / Puerto Montt / Coyhaique',
              acreditados: '6',
              puntaje: '679,12',
            },
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            data: {
              fundacion: '1849',
              rector: 'Rodrigo Vidal',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '766,48',
            },
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            data: {
              fundacion: '1989',
              rector: 'José Antonio Guzmán',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '674,18',
            },
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            data: {
              fundacion: '1989',
              rector: 'Eduardo Hebel Weiss',
              sedes: 'Temuco / Pucón / Angol',
              acreditados: '6',
              puntaje: '666,64',
            },
          },
        ],
      },
      {
        name: 'Tabla de Posiciones',
        link: '/rankings-generales/tabla-de-posiciones/',
        slug: 'tabla-de-posiciones',
        content: `<p>Aunque con pequeñas variaciones, el Top 10 está conformado por los mismos planteles que la versión pasada. Ocho de ellos mantienen sus posiciones, mientras que hay un intercambio de puestos: la U. Adolfo Ibáñez descendió a la sexta posición, instalándose en la quinta la U. Federico Santa María. Otras seis universidades mantuvieron sus lugares y 15 ascendieron: la U. de Tarapacá escaló cinco puestos, la Finis Terrae avanzó dos, y las universidades del Desarrollo, del Bío-Bío, Autónoma, Tecnológica Metropolitana, San Sebastián, Bernardo O'Higgins, Santo Tomás, de las Américas, Gabriela Mistral, de Viña del Mar, SEK y UNIACC, lo hicieron en uno.</p>
        <p>Entre estas alzas, destaca la U. de Tarapacá, que este año quedó en el 18° lugar. Su ascenso se explica por sus indicadores de percepción de calidad por parte de los empleadores, de gestión y de investigación. En el primer sub-ranking, avanzó cuatro puestos —del 33 al 29—, mientras que en el segundo avanzó 17 lugares. En este ranking, destaca el aumento de años de acreditación institucional, subió de cinco a seis años, ingresando así al club de las universidades de excelencia. En cuanto a investigación, incrementó sus publicaciones (20%) y el impacto que éstas tienen en la comunidad científica (21%).</p>`,
        pdflink:
          'https://especiales.latercera.com/ranking-universidades-2023-assets/01-tabla-de-posiciones.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
        ],
      },
      {
        name: 'Ranking de percepción de calidad del mercado laboral',
        link: '/rankings-generales/percepcion-de-calidad/',
        slug: 'percepcion-de-calidad',
        content: `
        <p>Durante 24 años, hemos registrado la percepción de calidad y nivel de conocimiento que los empleadores otorgan a las universidades chilenas. Este año fueron 2.900 los profesionales que participaron y sus opiniones fueron recogidas, en noviembre pasado, por la empresa de estudio e investigación de mercados Feedback.</p>
<p>A excepción de las universidades de O'Higgins y de Aysén, que comenzaron sus operaciones en 2015, los encuestados les pusieron nota a todos los planteles, sin embargo, se publican los resultados de las universidades que son medidas en este ranking, es decir las 48 casas de estudio que están acreditadas.</p>
<p>En la primera parte de la tabla, las líderes siguen siendo las universidades Católica y de Chile, primacía que tienen desde 1999, cuando realizamos la primera medición.</p>
<p>La U. Católica, de Chile y Santa María siguen en el Top 3, posición que mantienen desde hace más de una década.</p>
<p>La U. de La Serena y la U. de Tarapacá son las grandes ganadoras, ambas saltaron cuatro puestos, ubicándose en el 23 y el 29, respectivamente.</p>
<p>Este año, la de Valparaíso volvió a estar entre las 10 primeras universidades del ranking.</p>
<p>La sorpresa de este año, viene de la mano de las regiones. Las universidades de La Serena y de Tarapacá subieron cuatro puestos cada una, mientras que la U. de Talca escaló tres.</p>
<p>Las que descienden notoriamente son las universidades Finis Terrae, que bajó al lugar 28 y de Los Lagos al 33. Fueron 16 los planteles que en total bajaron su nota. Entre ellos, destaca la U. Adolfo Ibáñez, históricamente la casa de estudio ha ocupado la quinta posición, este año se instaló en el sexto lugar, cediendo el paso a la U. Católica de Valparaíso.</p>
<p>Al ingresar la U. del Alba al ranking —en la versión pasada no fue incluida debido a que no contaba con acreditación—, no registra valores para esa versión.</p>
        `,
        pdflink:
          'https://especiales.latercera.com/ranking-universidades-2023-assets/02-mercado-laboral.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
          },
        ],
      },

      {
        name: 'Ranking de calidad de la gestión',
        link: '/rankings-generales/percepcion-de-calidad-de-la-gestion/',
        slug: 'percepcion-de-calidad-de-la-gestion',
        content: `
        <p>Para ingresar al ranking, los planteles deben contar con acreditación institucional, de ahí que solo sean 48 las casas de estudio medidas. Una buena gestión no solo significa contar con esta certificación, sino que también existen otros factores, como la cantidad de años otorgados de la acreditación institucional, número de alumnos por cada jornada completa equivalente, capacidad de los planteles para conservar a sus estudiantes y la diferencia entre la duración formal de las carreras y lo que tarda un estudiante en titularse.</p>
<p>La U. Católica Silva Henríquez presenta la diferencia más baja entre la duración formal y real de una carrera: 1,4 semestres.</p>
<p>Ocho de cada 10 alumnos de 13 casas de estudio permanecen después de cursar el segundo año.</p>
<p>De los cuatro factores considerados, el que más pesa es el número de años otorgados en la acreditación institucional. La distinción por siete años, que es la máxima que entrega la CNA, la ostentan las universidades Católica, Católica de Valparaiso, de Chile, de Concepción y de Santiago. De las privadas, las únicas que cuenta con seis años son la U. Adolfo Ibáñez, Andrés Bello, de los Andes, del Desarrollo y Diego Portales, todas ellas consideradas de excelencia. Contrarias es la realidad de las universidades Adventista, UNIACC, del Alba, SEK, Gabriela Mistral y Miguel de Cervantes, que con solo 3 años acreditados, el periodo mínimo, se encuentran en un nivel de desarrollo básico.</p>
<p>El número de alumnos por jornada completas equivalentes es el segundo indicador considerado. Esta medida permite estandarizar la carga académica. Según datos del SIES, para 2023 se registran 21,9 estudiantes por JCE; sin embargo, son 26 universidades las que se encuentran por debajo de ese umbral, destacándola U. Metropolitana de Ciencias de la Educación, con 12 alumnos /JCE. Sobre ese promedio se dispara la U. Gabriela Mistral con 30 estudiantes/JCE.</p>`,

        contentafter: `<h3>Ingresar y permanecer en la universidad</h3>

        <p>Los principales motivos de la deserción en pregrado se relacionan con problemas socioeconómicos, crisis en la orientación vocacional y un rendimiento académico insuficiente. De las 48 universidades, destaca la U. de los Andes que presenta el índice más alto: 88% de sus alumnos permanecen después del segundo año. A ella, le siguen la Adolfo Ibáñez, Católica y de Chile, con 87% cada una.</p>
        <p>El cuarto factor mide la coherencia entre el tiempo establecido que duren los programas y lo que tarda un alumno en titularse. Según el informe Duración real y sobreduración de los programas de educación superior, del SIES, la duración real en 2022 fue 13,1 semestres, para un currículo establecido en 10,1 semestres. Las áreas con mayor duración real fueron Derecho (16,5 semestres), Ciencias Básicas (14,6), Agropecuaria (13,6) y Salud (13,3).</p>
        <p>Las universidades que las dictan, son precisamente las más afectadas en este indicador, pues sus alumnos tardan más en titularse. La U. Católica Silva Henríquez, presenta en promedio 1,4 semestres de diferencia entre la duración formal y la duración real. En tanto, la U. Santa María anotan una brecha que supera los 6,4 semestres.</p>
        `,

        pdflink:
          'https://especiales.latercera.com/ranking-universidades-2023-assets/03-calidad-gestion.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
          },
        ],
      },
      {
        name: 'Ranking de calidad de los académicos',
        link: '/rankings-generales/percepcion-de-calidad-de-los-academicos/',
        slug: 'percepcion-de-calidad-de-los-academicos',
        content: `<p>Para fortalecer la educación superior, la especialización del cuerpo docente es un factor clave. Una forma de medir la calidad de las instituciones es considerar el perfeccionamiento de los académicos. Precisamente, eso es lo que registra este ranking.</p>
        <p>Este año, lo encabezan las universidades Católica de Valparaíso, de Concepción y del Bío-Bío con índices de 97,6, 93,3 y 92,9, respectivamente. De las privadas, la Adolfo Ibáñez subió un puesto, desplazando a la Alberto Hurtado al 5° lugar.</p>
        <p>El informe sobre la caracterización del personal académico, publicado por el SIES en octubre pasado, señala que este año son 89 mil los académicos que trabajan en instituciones de educación superior, 3,8% más que el año pasado. Pero, este crecimiento no ha ido acompañado con un aumento de la formación académica, ya que, al igual que en 2022, solo un 16% tiene un doctorado.</p>
        <p>En todo caso, si sumamos a los profesionales que cuentan con algún magíster, cinco de cada 10 profesores tienen un posgrado. Se trata de números auspiciosos, ya que hay un incremento de 69% con respecto a 2013.</p>
        <p>También hay buenas noticias en paridad de género: el 46% de la planta son mujeres —la cifra más alta desde que se tiene estadísticas. En cuanto a la edad, el promedio es de 43 años, dos menos que los hombres.</p>
        <p>Y mientras en las universidades de clase mundial el cuerpo docente está conformado en su mayoría por profesores con doctorado, en nuestro sistema universitario sigue siendo escaso: solo 10 de las 48 casas de estudio tienen más del 50% de sus JCE con doctorado. La lista la encabeza la Católica de Valparaíso. Mientras que, en el opuesto, con menos de un 10%, aparecen la del Alba y UNIACC.</p>
        <p>Solo 10 de los 48 planteles que integran el ranking, tienen más del 50% de sus JCE con doctorado.</p>
        <p>La Universidad Católica de Valparaíso es el plantel que registra el mayor índice de JCE con doctorado: 65%.</p>        
        `,
        pdflink:
          'https://especiales.latercera.com/ranking-universidades-2023-assets/04-calidad-academicos.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad del Bío-Bío',
            abbr: 'U. del Bío-Bío',
            logo: 'Ubiobio',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad Alberto Hurtado',
            abbr: 'U. Alberto Hurtado',
            logo: 'UAH',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Tarapacá',
            abbr: 'U. Tarapacá',
            logo: 'UTarapaca',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
        ],
      },
      {
        name: 'Ranking de calidad de los alumnos',
        link: '/rankings-generales/percepcion-de-calidad-de-los-alumnos/',
        slug: 'percepcion-de-calidad-de-los-alumnos',
        content: `
        <p>Este ranking es uno de los más estables: los mejores alumnos de la promoción siguen optando por dos universidades, la PUC y la Chile. De las 10 primeras, ocho están en el top 10 del Ranking de Universidades, pero además son las mismas casas de estudio favoritas del mercado laboral.</p>
<p>Este año, fueron poco menos de 150 mil los estudiantes que ingresaron a un aula universitaria, un aumento de 13% con respecto al año pasado, revirtiendo así la tendencia a la baja, especialmente tras la fuerte caída experimentada en 2020. Actualmente, seis de cada 10 estudiantes de Educación Superior está en una universidad.</p>
<p>A nivel global del ranking, son 13 universidades las que mantuvieron su posición, mientras que otras 16 descendieron, registrando la mayor baja la U. Metropolitana de Ciencias de la Educación, con 6 puestos.</p>
<p>Entre la U. Católica, plantel que registra el puntaje PAES más alto, y la U. SEK, existe una diferencia de 269 puntos. Mientras los alumnos de la primera anotan 793, los de la segunda alcanzan los 524.</p>
<p>Actualmente, seis de cada 10 estudiantes de Educación Superior asiste a una de las 52 universidades vigentes en el país.</p>
<p>En tanto, las que subieron fueron la U. de Los Lagos, que saltó del lugar 41 al 35, mientras que las universidades Autónoma y Adventista, ascendieron 5 escalones.</p>
<p>En cuanto a las notas de Enseñanza Media, las cuatro mejores universidades son la PUC (6,67), la Chile (6,61), de los Andes (6,51) y Adolfo Ibáñez (6,49). La matrícula de los mejores promedios PAES también están en la PUC (792,51) y la Chile (766,2); de las privadas destacan la de los Andes (766,48) y Adolfo Ibáñez (749,96).</p>
        `,
        pdflink:
          'https://especiales.latercera.com/ranking-universidades-2023-assets/05-calidad-alumnos.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
          },
        ],
      },
      {
        name: 'Ranking de calidad de la investigación',
        link: '/rankings-generales/percepcion-de-calidad-de-la-investigacion/',
        slug: 'percepcion-de-calidad-de-la-investigacion',
        content: `
        <p>Este ranking registra el nivel de la investigación que se desarrolla en el país, considerando la cantidad de publicaciones (output), el impacto que éstas tienen en la comunidad científica internacional (impacto normalizado) y el porcentaje de trabajos publicados en las revistas que se encuentran en el 25% más alto de cada categoría del conocimiento (% publicaciones en Q1).</p>
<p>Dedicado al análisis en el desarrollo de investigaciones, SCImago Research Group es considerado por la comunidad académica y científica como la plataforma más completa en cuanto a clasificación de instituciones. El grupo utiliza la base de datos Scopus de Elsevier —la mayor fuente de información en literatura científica con más de 28 mil revistas—, para caracterizar el desempeño científico de 22 países iberoamericanos.</p>
<p>Este año, Chile se ubicó en el quinto lugar del Ranking SCImago Iber, detrás de México, Portugal, Brasil y España. Entre 2018 y 2022, el país indexó 90.164 publicaciones, de las cuales 42 mil corresponden a la producción de tres universidades: de Chile, Católica y de Concepción. Si bien aumentó la producción científica un 7,6% con respecto a la versión 2022, el impacto de ésta disminuyó, ya que solo un 10% de los papers son citados más que la media mundial. Es la U. de Antofagasta la que lidera, por segundo año, este indicador, pues sus papers son citados un 47% más que la media.</p>
<p>Mientras que el tercer indicador, lo encabeza la U. de La Serena: 65% de sus trabajos son publicados en revistas que pertenecen al Q1.</p>
<p>Las 90.164 publicaciones realizadas en Chile entre 2018 y 2022, dejaron al país en la quinta posición del ranking SCImago Iber, que mide la producción científica en 22 países iberoamericanos.</p>
<p>Son los papers de la U. de Antofagasta los que tienen el mayor impacto en la comunidad científica; mientras que la U. de La Serena publica un mayor porcentaje de sus trabajos en revistas del primer cuartil.</p>

        `,
        pdflink:
          'https://especiales.latercera.com/ranking-universidades-2023-assets/06-calidad-investigacion.pdf',
        ranking: [
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad Andrés Bello',
            abbr: 'U. Andrés Bello',
            logo: 'UNAB',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
          },
          {
            name: 'Universidad de La Serena',
            abbr: 'U. de La Serena',
            logo: 'USerena',
          },
          {
            name: 'Universidad de Antofagasta',
            abbr: 'U. de Antofagasta',
            logo: 'UAntofa',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
          },
        ],
      },
    ],
  },
  {
    name: 'Top 10 por Carrera',
    link: '/rankings-por-carrera/arquitectura/',
    adid: 'div-gpt-ad-rankingu-0',
    rankings: [
      {
        name: 'Arquitectura',
        link: '/rankings-por-carrera/arquitectura/',
        slug: 'arquitectura',
        adid: 'div-gpt-ad-rankingu-0',
        content: `
        <p>Poco más de 15.000 alumnos estudian en uno de los 40 programas que dictan 32 universidades; mientras que en primer año la matrícula llega a 3.593 estudiantes, convirtiéndola en la octava carrera que más estudiantes atrajo. Un recién titulado partirá ganando en promedio $968 mil, alcanzando $1.500.000 al quinto año de trabajo, según información de mifuturo.cl. Pese a que su duración formal es de 11,3 semestres, quienes ingresen deben tener presente que en promedio los alumnos demoran cuatro semestres más en titularse. Un 60% de los estudiantes estará trabajando a su primer año de titulación y un 74%, lo hará en su segundo año.</p>
          `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '95,66',
            ranking2021: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '93,99',
            ranking2021: '5',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '83,62',
            ranking2021: '4',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '82,94',
            ranking2021: '3',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '76,91',
            ranking2021: '7',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '76,28',
            ranking2021: '10',
          },
          {
            name: 'Universidad del Bío-Bío',
            abbr: 'U. del Bío-Bío',
            logo: 'Ubiobio',
            percepcion: '74,66',
            ranking2021: '8',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '74,25',
            ranking2021: '9',
          },
          {
            name: 'Universidad Central',
            abbr: 'U. Central',
            logo: 'UCentral',
            percepcion: '',
            ranking2021: '10',
          },
        ],
      },
      {
        name: 'Derecho',
        link: '/rankings-por-carrera/derecho/',
        slug: 'derecho',
        adid: 'div-gpt-ad-rankingu-3',
        content: `<p>El favoritismo de esta carrera queda en evidencia tras los 10 mil matriculados en 2023. Y aunque es una carrera larga y exigente —los alumnos tardan tres años más en titularse que lo establecido en los programas formales—, la gran demanda por estudiarla se explica, en parte, por los sueldos. Un recién egresado promedia sobre el millón de pesos mensual, subiendo a $2 millones al quinto año de titulado. En el tramo alto, en este mismo período, el 10% de los abogados percibirá $3.200.000, mientras que el 10% inferior recibirá $700 mil. Las cifras de empleabilidad también son auspiciosas. Al segundo año de titulación, el 80% de los profesionales estará trabajando.</p>

          `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '94,59',
            ranking2022: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '89,38',
            ranking2022: '3',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '88,86',
            ranking2022: '4',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '82,98',
            ranking2022: '5',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '81,40',
            ranking2022: '6',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '80,65',
            ranking2022: '7',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '78,93',
            ranking2022: '8',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '77,50',
            ranking2022: '9',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '71,41',
            ranking2022: '10',
          },
        ],
      },
      {
        name: 'Ingeniería Civil Industrial',
        link: '/rankings-por-carrera/civil/',
        slug: 'civil',
        adid: 'div-gpt-ad-rankingu-1',
        content: `
        <p>Hoy, 32 mil alumnos estudian esta carrera. La primera razón que explica su alta demanda tiene que ver con la inversión inicial que se realiza, la que se recupera a los pocos años de egreso. Un recién titulado parte ganando $1 millón 700 mil, cifra que al quinto año se incrementa en un millón. El sueldo mejora aún más entre quienes se ubican en torno al 10% superior: $5.800.000. La segunda razón tiene que ver con su alta tasa de empleabilidad: nueve de cada diez alumnos estará trabajando al segundo año de titulados. Estos profesionales siguen siendo muy requeridos por las diversas industrias del país. En 2023, más de 4.300 alumnos ingresaron a estudiarla. Pese a que formalmente los alumnos deberían cursarla en 11 semestres, finalmente pueden tardarse hasta 14.</p>

          `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '97,47',
            ranking2022: '2',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '94,02',
            ranking2022: '3',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '88,66',
            ranking2022: '4',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '82,86',
            ranking2022: '5',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '80,82',
            ranking2022: '6',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '78,39',
            ranking2022: '7',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '71,56',
            ranking2022: '9',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '70,12',
            ranking2022: '13',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '70,02',
            ranking2022: '10',
          },
        ],
      },
      {
        name: 'Ingeniería Comercial',
        link: '/rankings-por-carrera/comercial/',
        slug: 'comercial',
        adid: 'div-gpt-ad-rankingu-2',
        content: `<p>En 2023 se matricularon 9.250 alumnos, llegando a un total de 46 mil estudiantes inscritos en el país. ¿La razón? La proyección laboral de sus egresados: el 78% estará trabajando al primer año de titulado, subiendo a un 85% al segundo. Además, los sueldos, que pueden llegar en promedio a $2 millones al quinto año de ejercicio, sumado al amplio campo laboral, la convierten en la tercera licenciatura que más alumnos convoca. Por lo mismo, los titulados de este programa bordean los 8 mil 500 al año, y aunque no se trata de una carrera barata —el arancel anual oscila entre $2 millones y $8 millones—, es una disciplina que sigue aumentando las vacantes, pues todo indica que el mercado no está saturado. Formalmente su plan de estudios dura 10 semestres, aunque puede ampliarse en 12,5 semestres.</p> 
          `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '95,81',
            ranking2022: '2',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '91,96',
            ranking2022: '3',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '87,83',
            ranking2022: '4',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '83,75',
            ranking2022: '5',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '81,42',
            ranking2022: '6',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '78,97',
            ranking2022: '7',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '75,23',
            ranking2022: '9',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '74,44',
            ranking2022: '8',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '74,33',
            ranking2022: '10',
          },
        ],
      },
      {
        name: 'Medicina',
        link: '/rankings-por-carrera/medicina/',
        slug: 'medicina',
        adid: 'div-gpt-ad-rankingu-5',
        content: `<p>Pese a que son 7 años de estudios, más tres en promedio de especialización, un aspecto de Medicina sigue manteniéndola como favorita de los alumnos: altos sueldos y gran empleabilidad. Los casi 20 mil matriculados en la carrera a lo largo del país saben que, una vez egresados, pueden llegar a ganar cerca de $2.690.000, subiendo a $4 millones tras cinco años de ejercicio. Un mercado laboral que también premia a los futuros doctores con un 91% de ellos trabajando seguro tras egresar. Este 2024, las universidades del Bío-Bío y Central abrirán la carrera, con 40 y 50 vacantes, respectivamente.</p>

          `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '96,79',
            ranking2022: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '91,69',
            ranking2022: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '89,31',
            ranking2022: '4',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '84,33',
            ranking2022: '5',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '82,01',
            ranking2022: '7',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '81,75',
            ranking2022: '8',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '80,48',
            ranking2022: '6',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '77,58',
            ranking2022: '9',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '73,21',
            ranking2022: '10',
          },
        ],
      },
      {
        name: 'Odontología',
        link: '/rankings-por-carrera/odontologia/',
        slug: 'odontologia',
        adid: 'div-gpt-ad-rankingu-6',
        content: `<p>Las buenas proyecciones laborales explican el interés de los 14 mil alumnos que la estudian y de los 2.500 que ingresaron en 2023. El 80% de los alumnos tendrá empleo al segundo año de su titulación. Este indicador concuerda con la alta tasa de retención que tiene la carrera: solo dos de cada diez estudiantes deserta al segundo año de estudio. El otro factor para cursarla tiene que ver con las remuneraciones. Tras cinco años de ejercicio profesional, un odontólogo puede llegar a ganar $2 millones. Esta cifra puede aumentar hasta los $3 millones en el caso de los mejor remunerados, durante el mismo período.</p>
        `,

        ranking: [
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '99,16',
            ranking2022: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '95,31',
            ranking2022: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '93,62',
            ranking2022: '4',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '90,59',
            ranking2022: '5',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '89,72',
            ranking2022: '6',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '84,12',
            ranking2022: '8',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '83,37',
            ranking2022: '10',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '82,69',
            ranking2022: '7',
          },
          {
            name: 'Universidad Andrés Bello',
            abbr: 'U. Andrés Bello',
            logo: 'UNAB',
            percepcion: '81,34',
            ranking2022: '11',
          },
        ],
      },
      {
        name: 'Periodismo',
        link: '/rankings-por-carrera/periodismo/',
        slug: 'periodismo',
        adid: 'div-gpt-ad-rankingu-7',
        content: `
        <p>Si bien desde 2019 son las mismas 10 casas de estudios consideradas como las mejores, es primera vez que mantienen sus posiciones. Este año, poco más de 1.700 estudiantes ingresaron a la carrera, totalizando una matrícula de más de 7.600 mil alumnos. En la última década la demanda por ingresar a esta licenciatura ha incrementado notablemente, no así las proyecciones laborales: seis de cada 10 periodistas encontrará trabajo al año de ejercicio profesional y un 77% lo hará al segundo año. En tanto, los sueldos se mantienen. Un periodista recién titulado ganará cerca de $922 mil mensual, bordeando el 1 millón 300 pesos al quinto año de trabajo. La U. Adolfo Ibáñez no registra puntajes para el proceso de Admisión 2023, puesto que no tuvo ingresos. Ello, se debe al cambio curricular realizado en Periodismo, desde el próximo año dictará la Licenciatura en Comunicaciones, conducente al título de Periodista o Comunicador Estratégico.</p>
`,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '92,65',
            ranking2022: '2',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '86,57',
            ranking2022: '3',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '82,54',
            ranking2022: '4',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '81,62',
            ranking2022: '5',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '79,12',
            ranking2022: '6',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '76,78',
            ranking2022: '7',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '73,25',
            ranking2022: '8',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '72,21',
            ranking2022: '9',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '67,00',
            ranking2022: '10',
          },
        ],
      },
      {
        name: 'Psicología',
        link: '/rankings-por-carrera/psicologia/',
        slug: 'psicologia',
        adid: 'div-gpt-ad-rankingu-8',
        content: `<p>Psicología sigue en auge. Sube el interés por estudiarla con casi 48.600 matriculados en los 167 programas que se dictan en el país. Sin embargo, en relación a años anteriores su índice de empleabilidad baja. De los más de 11.200 estudiantes que ingresaron a primer año, el 60% de ellos estará trabajando al momento de titularse y el 75% lo hará al segundo año. Los ingresos de los futuros psicólogos son los más bajos de las carreras medidas en este ranking, junto a Periodismo. Al primer año de ejercicio, los profesionales ganarán casi $900 mil mensual, alcanzando un promedio de $1.280.000, tras cinco años. Los mejores remunerados alcanzarán a percibir $2 millones en un quinquenio de trabajo.</p>

          `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '94,61',
            ranking2022: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '90,99',
            ranking2022: '3',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '86,87',
            ranking2022: '4',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '86,14',
            ranking2022: '5',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '82,83',
            ranking2022: '6',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '77,57',
            ranking2022: '9',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '78,13',
            ranking2022: '8',
          },

          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '72,21',
            ranking2022: '11',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '77,57',
            ranking2022: '7',
          },
        ],
      },
      {
        name: 'Enfermería',
        link: '/rankings-por-carrera/enfermeria/',
        slug: 'enfermeria',
        adid: 'div-gpt-ad-rankingu-4',
        content: `
        <p>El boom por estudiarla se mantiene: 7.482 alumnos se matricularon en 2023, dejándola como la cuarta licenciatura favorita de los egresados de enseñanza media. Al segundo año de titulado, nueve de cada diez profesionales estará trabajando. Respecto de los salarios, un enfermero recién titulado ganará $1.372.000 y los mejores remunerados llegan a cerca de $2 millones tras cinco años de ejercicio profesional. Se trata de una carrera en la que sus estudiantes no tardan más de 3 semestres en terminarla. Además, tiene una baja deserción —ocho de cada 10 alumnos continúan en segundo año.</p>
        `,

        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100',
            ranking2022: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '98,78',
            ranking2022: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '95,63',
            ranking2022: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '89,17',
            ranking2022: '4',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '84,70',
            ranking2022: '5',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '84,52',
            ranking2022: '6',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '81,67',
            ranking2022: '7',
          },
          {
            name: 'Pontificia Universidad Católica de la Santísima Concepción',
            abbr: 'UC de la Santísima Concepción',
            logo: 'UCSConce',
            percepcion: '80,90',
            ranking2022: '9',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '80,59',
            ranking2022: '8',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '80,05',
            ranking2022: '10',
          },
        ],
      },
    ],
  },
]

export default rankingData
